// This file will be deleted once all the calculators are configBuilder free
// to be deleted

import React, { Component } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import Lazy from 'react-lazyload';

import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { applyMacros } from '@nerdwallet/react-config-builder';

import ImageSizes from '../../config/images/imageSizes';
import {
  getMortgageFreeCreditScore,
  getMortgageStateFreeCreditScore,
  getMortgagePaymentFreeCreditScore,
  getMortgageAmortizationFreeCreditScore,
} from '../../lib/analytics-constants';

// CSS
import './tool-link-cards.less';

class ToolLinkCards extends Component {
  getMCEventPayload = (mortgageCalType) => {
    switch (mortgageCalType) {
      case 'mortgage_state_calculator':
        return getMortgageStateFreeCreditScore();
      case 'mortgage_calculator':
        return getMortgageFreeCreditScore();
      case 'mortgage_payment_calculator':
        return getMortgagePaymentFreeCreditScore();
      case 'mortgage_amortization_calculator':
        return getMortgageAmortizationFreeCreditScore();
      default:
        return () => {};
    }
  };

  renderCard = ({ header, text, img, impressionEventPayload }, link, index) => {
    const { analyticsConfig, mortgageCalType, impressionTrackingName } =
      this.props;

    const snakedHeader = _.snakeCase(header);
    const { linkComponent: LinkComponent = 'a' } = link;

    let impressionPayload = { enabled: false };
    if (impressionEventPayload) {
      impressionPayload =
        typeof impressionEventPayload === 'function'
          ? impressionEventPayload(analyticsConfig)
          : impressionEventPayload;
    } else if (mortgageCalType) {
      impressionPayload = this.getMCEventPayload(mortgageCalType);
    }

    return (
      <div key={`${index}_${snakedHeader}`} className="tool-link-cards-card">
        <Impression {...impressionPayload}>
          <ImpressionContext.Consumer>
            {(impressionData) => (
              <div>
                <LinkComponent
                  className="tool-link-cards-card-link auth-modal-link"
                  href={link.url}
                  {...link.props}
                  {...(typeof link.getAdditionalProps === 'function'
                    ? link.getAdditionalProps(impressionData)
                    : {})}
                  impressionPayload={{ enabled: false }}
                  target="_blank"
                >
                  <h4 className="tool-link-cards-card-header">{header}</h4>
                  <Lazy>
                    <div className="tool-link-cards-card-content">
                      <img
                        className="tool-link-cards-card-img"
                        {...ImageSizes.largeIcon.measures}
                        src={img}
                        alt=""
                      />
                      {link.text}
                    </div>
                  </Lazy>
                  <ElementImpression
                    id={`mortgages-${impressionTrackingName}-${snakedHeader}`}
                    elementName={impressionTrackingName}
                    sectionCategory="resources"
                    elementCategory="card"
                    elementPosition={index}
                  >
                    <div />
                  </ElementImpression>
                  <p className="tool-link-cards-card-description">{text}</p>
                </LinkComponent>
              </div>
            )}
          </ImpressionContext.Consumer>
        </Impression>
      </div>
    );
  };

  render() {
    const { cards, data } = this.props;
    const macroCards = applyMacros(cards, data);
    return (
      <div className="tool-link-cards-list">
        {_.map(macroCards, (card, index) => {
          const link = applyMacros(
            {
              keys: card.keys,
              ...card.link,
            },
            data
          );
          return this.renderCard(card, link, index);
        })}
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ToolLinkCards.displayName = 'ToolLinkCards';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ToolLinkCards.propTypes = {
  impressionTrackingName: PropTypes.string,
  cards: PropTypes.array,
  data: PropTypes.object,
  mortgageCalType: PropTypes.string,
  analyticsConfig: PropTypes.shape({
    sectionName: PropTypes.string.isRequired,
    sectionPosition: PropTypes.number.isRequired,
  }),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ToolLinkCards.defaultProps = {
  impressionTrackingName: null,
  cards: [],
  data: {},
  mortgageCalType: '',
  analyticsConfig: {},
};

export default ToolLinkCards;
